// extracted by mini-css-extract-plugin
export default {"paygo-code":"CodeBox_paygo-code__MWbw-"};